
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/unterkuenfte",
      function () {
        return require("private-next-pages/[region]/unterkuenfte.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/unterkuenfte"])
      });
    }
  